import { FC, useMemo } from 'react';

export interface PostitWidgetProps {
  background_colour: string;
  text_colour: string;
  title: string;
  subtitle?: string;
  description: string;
  description_text_color?: string;
  sort_index: number;
  sortIndex?: number;
}

export const PostitWidget: FC<PostitWidgetProps> = ({
  background_colour = '#FFF',
  text_colour = '#000',
  description_text_color = '#000',
  title,
  subtitle,
  description
}) => {
  const widgetStyles = useMemo(
    () => ({
      'backgroundColor': background_colour,
      'color': text_colour
    }),
    [background_colour, text_colour]
  );

  return (
    <div
      style={widgetStyles}
      className="flex min-h-[300px] flex-col items-start justify-between p-[32px]">
      <div className="flex flex-col">
        <span
          className="mb-[16px] text-[48px] font-bold leading-[52px]"
          dangerouslySetInnerHTML={{
            __html: title
          }}></span>
        {!!subtitle && (
          <span
            className="text-[18px] font-medium"
            dangerouslySetInnerHTML={{
              __html: subtitle
            }}
          />
        )}
      </div>

      <div
        style={{ color: description_text_color || text_colour }}
        className="flex flex-col text-[14px] lg:text-[16px]">
        {!!description && (
          <span
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PostitWidget;
